import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PriceAlert } from 'src/app/models/price-alert';
import { TickerService } from 'src/app/api/ticker.service';
import { CurrenciesService } from 'src/app/api/currencies.service';
import { FiatExchangeRateService } from 'src/app/api/fiat-exchange-rate.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'price-alert',
  templateUrl: './price-alert.component.html',
  styleUrls: ['./price-alert.component.scss']
})
export class PriceAlertComponent implements OnInit {
  @Input() pair: string;
  @Input() priceAlert: PriceAlert;
  @Input() useGlobalCurrency = false;
  @Output() save = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  price = 0;
  currencies = ['', ''];
  fiatCurrencies = [];

  loading = false;
  error: string = null;
  success = false;
  verify = false;

  constructor(
    private tickerService: TickerService,
    private currenciesService: CurrenciesService,
  ) { }

  getFiatCurrencies() {
    this.currenciesService.getFiatSorted().subscribe(response => {
      this.fiatCurrencies = response.map(item => item.code);
      if (environment.currencies.globalCurrency) {
        this.fiatCurrencies.push(environment.currencies.globalCurrency);
      }
    }, err => {});
  }

  ngOnInit() {
    this.getFiatCurrencies();
    this.currencies = this.pair ? this.pair.split('-') : ['', ''];
    this.getTicker();
  }

  getTicker() {
    this.verify = false;

    if (!this.pair) {
      this.verify = true;
      return;
    }

    this.loading = true;
    this.error = null;
    this.tickerService.getTickerInfo(this.pair).subscribe(response => {
      this.loading = false;
      const priceValue = this.useGlobalCurrency ? response?.usdData?.price : response?.data?.price;
      this.price = priceValue ? parseFloat(priceValue) : 0;
    }, err => {
      this.loading = false;
      this.error = err.errors[0].message;
      this.price = 0;
    });
  }

  onSave() {
    this.save.emit();
  }

  onClose() {
    this.close.emit();
  }
}
